<template>
<div class="order-submitted-stage quick-form">
  <div v-if="!settings.thank_you_image" class="quick-form__icon">
    <IconSaltBae/>
  </div>
  <div v-else class="mb-4">
    <a :href="settings.thank_you_image" target="_blank" rel="noopener nofollow">
      <img :src="settings.thank_you_image" alt="" class="rounded-lg">
    </a>
  </div>

  <template v-if="shouldDisplayThankYouMessage">
    <h2 class="quick-form__title">{{ settings.thank_you_title }}</h2>

    <div class="quick-form__subtitle thank-you-message" v-if="settings.thank_you_text" v-html="settings.thank_you_text"></div>

    <p class="quick-form__subtitle">
      Следите за статусом заказа в личном кабинете
      <template v-if="hasNativeApps">
        или нашем мобильном приложении
      </template>
    </p>

    <router-link :to="{ name: 'dashboard' }" class="btn btn-primary btn-sm btn-block btn-rounded quick-form__max-width-block">
      Перейти в личный кабинет
    </router-link>

    <template v-if="hasNativeApps">
      <p class="order-submitted-stage__or-download-app-text">или скачать приложение</p>
      <NativeAppLinks/>
    </template>

    <div class="socials-list">
      <SocialsList />
    </div>
  </template>
  <template v-else>
    <h2 class="quick-form__title">Заказ ожидает оплаты</h2>
    <p class="quick-form__subtitle">
      Ваш заказ был успешно создан, он будет оформлен после оплаты.
    </p>
    <template v-if="onlinePaymentStatus !== 'completed'">
      <button v-if="!onlinePaymentIsActive"
              type="button"
              class="btn btn-primary btn-sm btn-block btn-rounded quick-form__max-width-block"
              @click="startOnlinePayment"
      >
        Оплатить заказ
      </button>
      <template v-else>
        <p>Дождитесь окончания оплаты заказа.</p>
      </template>
      <div v-if="onlinePaymentStatus === 'failed' && !onlinePaymentIsActive" class="mt-4 font-light">
        <p class="text-danger">Не удалось завершить онлайн-платёж.</p>
        <p class="mt-2">
          Вы можете повторить попытку сейчас или оплатить заказ позже.

          Ссылка на оплату будет доступна в
          <router-link :to="{ name: 'dashboard' }"
                       class="font-bold text-primary hover:underline hover:text-primary-light"
          >
            личном кабинете
          </router-link>.
        </p>
      </div>
    </template>
  </template>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from '@/zenky';
import CloudpaymentsProcessor from '@/components/payments/CloudpaymentsProcessor';
import SocialsList from '@/components/socials/SocialsList.vue';

export default {
  props: {
    onlinePaymentRequired: {
      required: false,
      type: Boolean,
      default: false,
    },

    orderId: {
      required: false,
      type: String,
      default: '',
    },

    orderToken: {
      required: false,
      type: String,
      default: '',
    },
  },

  components: {
    IconSaltBae: () => import(/* webpackPreload: true */ '@/assets/images/icons/icon-salt-bae.svg?inline'),
    NativeAppLinks: () => import('@/components/NativeAppLinks'),
    SocialsList,
  },

  mounted() {
    this.loadOnlinePaymentTransaction()
  },

  computed: {
    ...mapGetters({
      hasNativeApps: 'store/hasNativeApps',
      settings: 'settings/orders',
    }),

    shouldDisplayThankYouMessage() {
      if (!this.onlinePaymentRequired) {
        return true
      } else if (this.onlinePaymentStatus === 'completed') {
        return true
      }

      return false
    },
  },

  methods: {
    loadOnlinePaymentTransaction() {
      if (!this.orderId || !this.orderToken) {
        this.onlinePaymentStatus = 'completed';

        return;
      }

      axios.get(`orders/${this.orderId}?token=${this.orderToken}&with=payments`)
        .then(({ data }) => {
          const transaction = data.data.payments
            .find(transaction => transaction.status.id === 'pending' && transaction.method.id === 'cloudpayments')

          if (!transaction) {
            this.onlinePaymentIsActive = false
            this.onlinePaymentStatus = 'failed'
          } else {
            this.onlinePaymentTransaction = transaction
            this.startOnlinePayment()
          }
        })
    },

    startOnlinePayment() {
      if (this.onlinePaymentIsActive) {
        return
      }

      this.onlinePaymentIsActive = true

      const processor = new CloudpaymentsProcessor(
        document,
        this.onlinePaymentTransaction,
        this.orderId,
        this.orderToken
      )

      processor.start()
        .then(() => {
          this.onlinePaymentIsActive = false
          this.onlinePaymentStatus = 'completed'
        })
        .catch(err => {
          this.onlinePaymentIsActive = false
          this.onlinePaymentStatus = 'failed'
        })
    },
  },

  data() {
    return {
      onlinePaymentStatus: 'pending',
      onlinePaymentIsActive: false,
      onlinePaymentTransaction: null,
    }
  }
}
</script>

<style lang="less">
@import '~@/assets/less/components/quick-form';

.order-submitted-stage {
  &__or-download-app-text {
    @apply text-sm text-dark-light leading-loose my-2;
  }

  .thank-you-message {
    a {
      @apply text-primary;

      &:hover {
        @apply text-primary-dark underline;
      }
    }
  }

  .socials-list {
    @apply mt-4;
    nav {
      ul {
        li {
          @apply inline-block mr-1 mt-1;

          &:last-child {
            @apply mr-0;
          }

          a {
            @apply bg-primary w-8 h-8 text-white rounded flex items-center justify-center;

            &:hover {
              @apply bg-primary-dark;
            }
          }
        }
      }
    }
  }
}
</style>
